<template>
  <div class="team_overview">
    <div class="header mb16 Disp_AC" @click="goBack">
      <cl-page-back class="cl_people_back" icon="page_back_3a"></cl-page-back>
      <span class="fs22 stage_name">{{ routerInfo.name }}</span>
    </div>
    <div class="team_content">
      <team-formation
        :player-list="playerList"
        @update-info="initPeoples"
        :disabled="true"
        :showPreview="false"
      ></team-formation>
      <div class="people_container">
        <cl-tabs
          :options="tabList"
          v-model="currentTab"
          active-bg-color="#fff"
          default-bg-color="#F9F9F9"
          active-color="#3A3A3A"
          default-color="#B7B7BF"
          @tab-click="tabClick"
        ></cl-tabs>
        <div v-if="isPlayer" class="player_list">
          <div v-if="playerLength">
            <dl
              v-for="(people, title) in playerGroup"
              :key="title"
              class="player_group"
            >
              <template v-if="people && people.length">
                <dt class="SysFontM">
                  {{
                    getValueByKeyStatic(title, playerPosition) || defaultText
                  }}
                </dt>
                <dd>
                  <div
                    class="player_item"
                    v-for="item in people"
                    :key="item.id"
                    @click="handleDetail(item)"
                  >
                    <span>{{ item.number }}</span>
                    <p class="avatar_box mr32">
                      <cl-avatar
                        :src="item.avatar"
                        round
                        :width="40"
                        :height="40"
                      ></cl-avatar>
                    </p>
                    <i class="SysFontM">{{ item.name || defaultText }}</i>
                  </div>
                </dd>
              </template>
            </dl>
          </div>
          <cl-no-data v-if="!playerLength"></cl-no-data>
        </div>
        <div v-else class="staff_list">
          <p v-if="staffLength" class="title SysFontM">
            {{ $t("schedule.教练组") }}
          </p>
          <div v-if="staffLength">
            <dl v-for="item in staffList" :key="item.id" class="staff_item">
              <dt class="avatar_box">
                <cl-avatar
                  :src="item.avatar"
                  round
                  width="40"
                  height="40"
                ></cl-avatar>
              </dt>
              <dd>
                <p class="SysFontM">{{ item.name || defaultText }}</p>
                <span>{{ item.title }}</span>
              </dd>
            </dl>
          </div>
          <cl-no-data v-if="!staffLength"></cl-no-data>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import teamFormation from "./teamFormation.vue";
export default {
  components: {
    teamFormation,
  },
  data() {
    return {
      teamId: "", // 梯队id
      playerList: [], //球员列表
      staffList: [], // 教练员列表
      playerGroup: {
        forward: [],
        midfielder: [],
        defender: [],
        goalkeeper: [],
        other: [],
      }, // 球员分组
      currentTab: "player", // 当前tab
      tabList: [
        // tab列表
        { title: "schedule.球员组", key: "player" },
        { title: "schedule.教练组", key: "staff" },
      ],
      defaultText: "--", // 默认占位符
      routerInfo: {},
      playerPosition: [
        {
          key: "forward",
          value: "前锋",
          valueEn: "Forward",
        },
        {
          key: "midfielder",
          value: "中场",
          valueEn: "Midfielder",
        },
        {
          key: "defender",
          value: "后卫",
          valueEn: "Defender",
        },
        {
          key: "goalkeeper",
          value: "守门员",
          valueEn: "Goalkeeper",
        },
      ],
    };
  },
  computed: {
    // 是否是球员
    isPlayer() {
      let boolean = this.currentTab === "player";
      return boolean;
    },
    playerLength() {
      let boolean = Object.keys(this.playerGroup).length;
      return boolean;
    },
    staffLength() {
      let boolean = this.staffList.length;
      return boolean;
    },
  },
  mounted() {
    // 向本地取出teamCurrentTab字段
    this.currentTab = "player";
    this.getTeamInfo();
  },
  methods: {
    // 返回上一页
    goBack() {
      this.$router.push({
        path: "/assemble",
        query: {
          year: this.$route.query.year,
          formPath: this.$route.query.formPath,
        },
      });
    },
    // 获取梯队信息时
    getTeamInfo() {
      this.routerInfo = this.$route.query;
      if (this.routerInfo && this.routerInfo.id) {
        this.teamId = this.routerInfo.id;
        this.initPeoples();
      }
    },
    // 初始化人员列表
    initPeoples() {
      let params = {
        tenant_id: this.routerInfo.tenant_id,
      };
      if (this.isPlayer) {
        params.user_type = "player";

        this.$server.getTrainingsPlayer(this.teamId, params).then((res) => {
          this.playerList = res.data || [];
          this.objectSort(res.data);
        });
      } else {
        params.user_type = "staff";

        this.$server.getTrainingsPlayer(this.teamId, params).then((res) => {
          this.staffList = res.data || [];
        });
      }
      console.log(this.playerGroup, "playerGroup");
    },
    // 对象排序
    objectSort(data) {
      if (data) {
        let sortArr = [
          "forward",
          "midfielder",
          "defender",
          "goalkeeper",
          "other",
        ]; // 新的排序数组   // 新对象
        sortArr.forEach((key) => {
          this.playerGroup[key] = [];
          data.forEach((item) => {
            if (!item.position) {
              this.playerGroup["other"].push(item);
            } else if (key === item.position) {
              this.playerGroup[key].push(item);
            }
          });
        });
      }
    },
    // tab 点击时
    tabClick(tab) {
      this.$sg.ls.set("teamCurrentTab", tab); // 本地存取当前tab值
      this.initPeoples();
    },
    // 跳转详情
    handleDetail(item) {
      this.$router.push({
        path: "/player/details",
        query: {
          id: item.id,
          tenant_id: this.routerInfo.tenant_id,
        },
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.team_overview {
  //display: flex;
  //flex-direction: column;
  position: relative;
  box-sizing: border-box;
  padding: 13px 24px 0 24px;
  background-color: #f3f3f3;
  color: #3a3a3a;
  .header {
    cursor: pointer;
  }
  .team_content {
    overflow: hidden;
    padding-top: 5px;
    flex: 1;
    display: flex;
    height: calc(100% - 80px);
    .people_container {
      width: calc(100% - 786px - 16px);
      .player_list {
        overflow-y: auto;
        height: calc(100% - 48px);
        background: #fff;
        border-radius: 0px 6px 6px 6px;
        position: relative;
        dl.player_group {
          padding: 0 12px;
          display: flex;
          flex-direction: column;
          font-family: "PingFang SC";
          font-size: $base-fontSize-16;
          color: $base-font-major;
          dt {
            line-height: 22px;
            padding: 24px 0 12px 12px;
          }
          dd {
            width: 100%;
            .player_item {
              height: 64px;
              display: flex;
              align-items: center;
              border-bottom: 1px solid $base-border-color-one;
              margin: 0 12px;
              cursor: pointer;
              &:hover {
                margin: 0;
                padding: 0 12px;
                border-radius: $base-border-radius-mini;
                background: $base-blue-linear;
                color: #fff;
                span {
                  color: #fff;
                }
              }
              span {
                display: inline-block;
                width: 45px;
                color: $base-color-theme;
                font-family: "AkrobatRegular";
                font-weight: 700;
                font-size: $base-fontSize-24;
                line-height: 30px;
              }

              img.icon {
                width: 21px;
                height: 21px;
                margin-right: 10px;
              }
              i {
                // width: 30%;
                line-height: 20px;
                display: inline-block;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                font-style: normal;
                margin-right: 10px;
              }
            }
          }
        }
      }
      .staff_list {
        height: calc(100% - 48px);
        background: #fff;
        border-radius: 0px 6px 6px 6px;
        padding: 0 12px;
        font-family: "PingFang SC";
        font-size: $base-fontSize-16;
        color: $base-font-major;
        p.title {
          line-height: 22px;
          padding: 24px 0 12px 12px;
        }
        & > div {
          overflow-y: auto;
          height: calc(100% - 58px);
          dl.staff_item {
            height: 70px;
            margin: 0 12px;
            border-bottom: 1px solid $base-border-color-one;
            display: flex;
            align-items: center;
            cursor: pointer;
            &:hover {
              margin: 0;
              padding: 0 12px;
              border-radius: $base-border-radius-mini;
              background: $base-blue-linear;
              color: #fff;
              span {
                color: #fff;
              }
            }
            &:last-child {
              border-bottom: none;
            }
            dt {
              width: 40px;
              height: 40px;
              border-radius: 50%;
              overflow: hidden;
              margin-right: 16px;
              img {
                width: 40px;
                height: auto;
              }
            }
            dd {
              width: 60%;
              p {
                width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                line-height: 22px;
                margin-bottom: 2px;
              }
              span {
                line-height: 17px;
                font-size: $base-fontSize-12;
                color: $base-font-minor;
              }
            }
          }
        }
      }
    }
  }
  .avatar_box {
    filter: drop-shadow(0px 6px 8px rgba(54, 99, 225, 0.16));
  }
}
</style>
